const RankTypes = {
    FETCH_START:    '[SERVERS][RANK] FETCH START',
    FETCH_SUCCESS:  '[SERVERS][RANK] FETCH SUCCESS',
    FETCH_FAILURE:  '[SERVERS][RANK] FETCH FAILURE'
};

export default RankTypes;